// this is a non-Vue equivalent of TextareaAutogrow.vue
up.compiler('.js-textarea_autogrow_container', function (element) {
  const resize = function (textarea, hiddenDiv) {
    /*
    Copy the textarea contents to the hidden div. This will make the textarea container grow
    and the textarea will also grow, as it's set to height: 100%.
    Adding '&nbsp;' solves an initial mismatch in height when the line is empty.
    */
    hiddenDiv.innerHTML = textarea.value.replace(/\n/g, '<br/>') + '&nbsp;'
  }

  const textarea = element.querySelector('textarea')
  const hiddenDiv = element.querySelector('div')

  resize(textarea, hiddenDiv)

  up.on(textarea, 'input', function () {
    resize(textarea, hiddenDiv)
  })
})
